import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../components/Login')
  },
  {
    path: '/sku',
    name: 'sku',
    component: () => import('../components/Sku')
  },
  
  {
    path: '/list',
    name: 'list',
    component: () => import('../components/List')
  },
  
  {
    path: '/edit/:id',
    name: 'edit',
    component: () => import('../components/Edit')
  },
  {
    path: '/buscar',
    name: 'buscar',
    component: () => import('../components/BuscarCheque')
  },
  {
    path: '/creditos',
    name: 'creditos',
    component: () => import('../components/Creditos')
  },
  {
    path: '/contabilidad',
    name: 'contabilidad',
    component: () => import('../components/Contabilidad')
  },
  {
    path: '/buscarcreditos',
    name: 'buscarcreditos',
    component: () => import('../components/BuscarCreditos')
  },
  {
    path: '/estadisticas',
    name: 'estadisticas',
    component: () => import('../components/Estadisticas')
  },
  {
    path: '/vales',
    name: 'vales',
    component: () => import('../components/Vales')
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../components/Personal')
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('../components/Menu')
  },
  {
    path: '/menutransportes',
    name: 'menutransportes',
    component: () => import('../components/MenuTransportes')
  },
  {
    path: '/stockcaja',
    name: 'stockcaja',
    component: () => import('../components/StockCaja')
  },
  {
    path: '/cierrecaja',
    name: 'cierrecaja',
    component: () => import('../components/CierreCaja')
  },
  {
    path: '/valestransportes',
    name: 'valestransportes',
    component: () => import('../components/ValesTransportes')
  },
  {
    path: '/entregaproductos',
    name: 'entregaproductos',
    component: () => import('../components/EntregaProductos')
  },
  {
    path: '/entregaproductostransportes',
    name: 'entregaproductostransportes',
    component: () => import('../components/EntregaProductosTransportes')
  },
  {
    path: '/solicitudes',
    name: 'solicitudes',
    component: () => import('../components/Solicitudes')
  },
  {
    path: '/valessolicitados',
    name: 'valessolicitados',
    component: () => import('../components/ValesSolicitados')
  },
  {
    path: '/valessolicitadostransportes',
    name: 'valessolicitadostransportes',
    component: () => import('../components/ValesSolicitadosTransportes')
  },
  {
    path: '/solicitudestransportes',
    name: 'solicitudestransportes',
    component: () => import('../components/SolicitudesTransportes')
  },
  {
    path: '/solicitudescaja',
    name: 'solicitudescaja',
    component: () => import('../components/SolicitudesCaja')
  },
  {
    path: '/valescaja',
    name: 'valescaja',
    component: () => import('../components/ValesCaja')
  },
  {
    path: '/valessolicitadoscaja',
    name: 'valessolicitadoscaja',
    component: () => import('../components/ValesSolicitadosCaja')
  },
  {
    path: '/ropa',
    name: 'ropa',
    component: () => import('../components/EntregarRopa')
  },
  {
    path: '/ropaextra',
    name: 'ropaextra',
    component: () => import('../components/EntregarRopaExtra')
  },
  {
    path: '/listropa',
    name: 'listropa',
    component: () => import('../components/ListRopa')
  },
  {
    path: '/pruebalistados',
    name: 'pruebalistados',
    component: () => import('../components/pruebalistados')
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router